import Swiper from 'swiper'

window.addEventListener('DOMContentLoaded', () => {
  // 注目の病院情報カルーセル
  const hospitalSwipers = document.querySelectorAll('.m__carousel--hospital-list .hospital-swiper')
  if (hospitalSwipers.length > 0) {
    hospitalSwipers.forEach((el) => {
      const sliderCount = el.children[0].children.length
      const searchArea = document.querySelector('.m__top__search-area')
      const isStudentOrResident = searchArea.classList.contains('m__top__search-area--student') ||
        searchArea.classList.contains('m__top__search-area--resident')

      let slidesPerView = 4
      let loopSetting = sliderCount > 2

      if (isStudentOrResident && window.innerWidth > 767) {
        slidesPerView = 2
        loopSetting = sliderCount > 1
      }

      new Swiper('.hospital-swiper', {
        loop: loopSetting,
        slidesPerView,
        spaceBetween: 10,
        autoplay: {
          delay: 5000
        },
        navigation: {
          nextEl: '.m__carousel--hospital-list .js-swiper-next',
          prevEl: '.m__carousel--hospital-list .js-swiper-prev'
        },
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 6
          }
        }
      })
    })
  }
})
